export enum UserAction {
  Click = 'Click',
  Delete = 'Delete',
  View = 'View',
  Filter = 'Filter',
  PrescriptionNew = 'PrescriptionNew',
  PrescriptionModify = 'PrescriptionModify',
  PrescriptionDelete = 'PrescriptionDelete',
  PrescriptionStop = 'PrescriptionStop',
  PrescriptionModifyCancel = 'PrescriptionModifyCancel'
} 